
import '../../../App.css';
import './propertygroup.css';

interface PropertyGroupProps {
  titleComponent: { title: string, name: string, id: string }
  groupContent?: JSX.Element
}

const PropertyGroup = ({ titleComponent, groupContent }: PropertyGroupProps) => {

  // Render differently for different shapes
  return (
    <div className='sidepanel__elementgroup' key={titleComponent.id}>
      <div className="sidepanel__element" >
        <div className='property__element__title'>
          <div className='element__part__name'>{titleComponent.title}</div>
          <div className='element__part__name'> {titleComponent.name}{titleComponent.id}</div>
        </div>
        {groupContent}
      </div >
    </div>
  )

};

export default PropertyGroup;